import GA4React from "ga-4-react";

/** Class for Google Analytics utilities. */
export class GaAnalytics {
    ga4Instance: any;
    isInitialized: boolean = false;

    /** Given a tag id, crate a new instance of Google Analytics for firing gtag events.
     * @param {string} id - The tag ID of a Google Analytics data stream. */
    public static async create(id: string) {
        const instance = new GaAnalytics();
        const ga4Instance = await GaAnalytics.initializeAnalytics(id);
        instance.ga4Instance = ga4Instance;
        instance.isInitialized = true;
        return instance;
    }

    static async initializeAnalytics(id: string) {
        const ga4React = new GA4React(id);
        return await ga4React.initialize();
    }

    recordEvent(category: EventCategory, action: string) {
        if (!this.isInitialized) {
            console.log("Analytics not initialized. Do not record.");
            return;
        }
        console.log("Action Event: " + category);
        if (action.length > 0) {
            this.ga4Instance.gtag("event", category, {"choice_text": action});
            return;
        }
        this.ga4Instance.gtag("event", category);
    }
}

export enum EventCategory {
    CHOICE = "Choice", RESTART = "Restart Game", RATE = "Rate", FINISH_GAME = "Finished Game"
}